import { useEffect, useState } from "react";

import { Project } from "../../models/project";
import ProjectSettingsModal from "../projectSettingsModal/ProjectSettingsModal";

import "./project-box.css";
import PermissionGuard from "../permissionGuard/PermissionGuard";
import EditIcon from '@mui/icons-material/Edit';

interface ProjectBoxProps {
    project: Project
    updateProject: (project: Project, newProject: Project) => void
}
export default function ProjectBox({ project, updateProject }: ProjectBoxProps) {
    const [expand, setExpand] = useState(false);
    const [thresholdModal, setThresholdModal] = useState(false);

    const clickBox = () => {
        if (project.completed) {
            setExpand(false);
            return;
        }
        setExpand(!expand);
    }

    useEffect(() => {
        if (project.completed) {
            setExpand(false);
        }
    }, [project.completed])

    {/* TODO: Make it so a user can change the name of project in edit mode */ }
    return (
        <div
            className={`project-box ${expand ? "expanded" : ""} ${project.completed ? "completed" : ""}`}
            id={`${project.name}-box`}
            onClick={clickBox}
        >

            <div className={`project-name ${expand ? "expanded" : ""} ${project.completed ? "completed" : ""}`}>
                {project.name}
                {project.completed && <span className="completed-text"> (Completed)</span>}

                {!project.completed && (
                    <PermissionGuard requiredScopes={["project:maintain"]}
                        alt={<div className="project-buttons ps-error">You don't have permissions to modify projects.</div>}>
                        <button
                            onClick={(e) => { e.stopPropagation(); setThresholdModal(v => !v); }}
                            title="Edit project"
                            className="edit-icon"
                        >
                            <EditIcon fontSize="medium" />
                        </button>

                    </PermissionGuard>
                )}
            </div>

            {expand && <div className="project-box-expansion" onClick={(e) => e.stopPropagation()}>
                <div className="project-description">{project.description}</div>
                <div className="project-count">Count: {project.count}</div>
            </div>}

            <ProjectSettingsModal
                isOpen={thresholdModal}
                creating={false}
                onClose={() => setThresholdModal(false)}
                project={project}
                updateProject={updateProject}
            />
        </div>
    );
}